import React, { useState } from 'react';
import './Energy.css';

const GRAFANA_BASE = import.meta.env.VITE_API_URL;
const DASHBOARD_SLUG = 'energy';
const THEME = 'dark';
const FROM = 'now-6h';
const TO = 'now';

// UIDs de los dashboards
const DASHBOARD_UIDS = {
  'CON_L8': '7076be15-4597-44ea-a56c-f3fb2c2101eb',
  'CON_L8_MONTHVIEW': '179ce203-6e7d-4c76-8402-dc1e4350220e',
  'CON_L8_MONTHVIEW_COMPAIRING': '398419ed-f22b-4c68-8b69-fdc9f569a1d3',
  'CON_L8_YEARVIEW': 'ffcf9d31-f175-4fa0-a41c-a99a7884d0e4',
  'CON_L8_YEARVIEW_COMPAIRING': 'ff429d74-3c44-483b-b7fb-32538c4dfc40',
  'FACTORY': 'bdl2js28fqozks'
};

const Energy = () => {
  const [selectedDashboard, setSelectedDashboard] = useState('CON_L8_YEARVIEW_COMPAIRING'); // Por defecto el actual
  
  const dashboardUid = DASHBOARD_UIDS[selectedDashboard];
  const iframeUrl = `${GRAFANA_BASE}/d/${dashboardUid}/${DASHBOARD_SLUG}?orgId=1&kiosk&theme=${THEME}&from=${FROM}&to=${TO}`;

  return (
    <div className="energy-quality">
      <header className="energy-header">
        <h1>⚡ Energy</h1>
        <p>Dashboard de energía</p>
      </header>
      
      {/* Menú de selección de dashboards */}
      <div className="energy-menu">
        <button
          className={`energy-menu-item ${selectedDashboard === 'CON_L8' ? 'active' : ''}`}
          onClick={() => setSelectedDashboard('CON_L8')}
        >
          CON_L8
        </button>
        <button
          className={`energy-menu-item ${selectedDashboard === 'CON_L8_MONTHVIEW' ? 'active' : ''}`}
          onClick={() => setSelectedDashboard('CON_L8_MONTHVIEW')}
        >
          CON_L8_MONTHVIEW
        </button>
        <button
          className={`energy-menu-item ${selectedDashboard === 'CON_L8_MONTHVIEW_COMPAIRING' ? 'active' : ''}`}
          onClick={() => setSelectedDashboard('CON_L8_MONTHVIEW_COMPAIRING')}
        >
          CON_L8_MONTHVIEW_COMPAIRING
        </button>
        <button
          className={`energy-menu-item ${selectedDashboard === 'CON_L8_YEARVIEW' ? 'active' : ''}`}
          onClick={() => setSelectedDashboard('CON_L8_YEARVIEW')}
        >
          CON_L8_YEARVIEW
        </button>
        <button
          className={`energy-menu-item ${selectedDashboard === 'CON_L8_YEARVIEW_COMPAIRING' ? 'active' : ''}`}
          onClick={() => setSelectedDashboard('CON_L8_YEARVIEW_COMPAIRING')}
        >
          CON_L8_YEARVIEW_COMPAIRING
        </button>
        <button
          className={`energy-menu-item ${selectedDashboard === 'FACTORY' ? 'active' : ''}`}
          onClick={() => setSelectedDashboard('FACTORY')}
        >
          FACTORY
        </button>
      </div>

      <div className="energy-iframe-container">
        <iframe
          key={dashboardUid} // Key para forzar recarga cuando cambia el dashboard
          src={iframeUrl}
          title={`Dashboard Grafana - Energy - ${selectedDashboard}`}
          className="energy-grafana-iframe"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          allow="fullscreen"
        />
      </div>
    </div>
  );
};

export default Energy;